<template>
  <div class="ticket-list">
    <a-spin :spinning="loading">
      <template v-if="safeTickets.length">
        <a-row :gutter="[16, 16]">
          <a-col
            v-for="ticket in safeTickets"
            :key="ticket.ticketNumber"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="6"
          >
            <a-card
              hoverable
              class="ticket-card custom-card"
              :bordered="false"
              @click="selectTicket(ticket)"
            >
              <div class="ticket-header">
                <span class="ticket-number">Bilet #{{ ticket.ticketNumber }}</span>
                
                <!-- Natija statistikasi (agar mavjud bo'lsa) -->
                <div v-if="ticket.stats" class="result-badge" :class="getResultClass(ticket.stats)">
                  {{ getResultText(ticket.stats) }}
                </div>
              </div>
              
              <!-- Test oralig'i (DOIM ko'rinadi) -->
              <div class="test-range">
                <span class="range-label">Test oralig'i:</span>
                <span class="range-value">
                  {{ ticket.start_question_order || 1 }} - {{ ticket.end_question_order || (ticket.question_count || 20) }}
                </span>
              </div>
              
              <!-- Natijalar statistikasi (agar mavjud bo'lsa) -->
              <div v-if="ticket.stats" class="stats-container">
                <div class="stat-item success">
                  <span class="stat-value">{{ ticket.stats.correct || 0 }}</span>
                  <span class="stat-label">to'g'ri</span>
                </div>
                <div class="stat-item danger">
                  <span class="stat-value">{{ ticket.stats.wrong || 0 }}</span>
                  <span class="stat-label">xato</span>
                </div>
                <div class="stat-item warning">
                  <span class="stat-value">{{ ticket.stats.skipped || 0 }}</span>
                  <span class="stat-label">ishlanmagan</span>
                </div>
              </div>
              
              <!-- Progress bar (agar natijalar bo'lsa) -->
              <!-- <div v-if="ticket.stats" class="progress-bar">
                <div 
                  class="progress-segment success" 
                  :style="{ width: getSuccessWidth(ticket.stats) + '%' }"
                ></div>
                <div 
                  class="progress-segment danger" 
                  :style="{ width: getDangerWidth(ticket.stats) + '%' }"
                ></div>
                <div 
                  class="progress-segment warning" 
                  :style="{ width: getWarningWidth(ticket.stats) + '%' }"
                ></div>
              </div>
               -->
              <!-- Agar natijalar bo'lmasa, faqat oraliq ko'rinadi (yuqorida) -->
            </a-card>
          </a-col>
        </a-row>
      </template>

      <template v-else>
        <div class="empty-state">
          <a-empty description="Biletlar topilmadi" />
        </div>
      </template>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'TicketList',

  props: {
    tickets: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['select'],

  computed: {
    safeTickets() {
      return Array.isArray(this.tickets) ? this.tickets : []
    }
  },

  methods: {
    selectTicket(ticket) {
      this.$emit('select', ticket)
    },

    getResultClass(stats) {
      if (!stats) return ''
      
      const total = (stats.correct || 0) + (stats.wrong || 0) + (stats.skipped || 0)
      const correctPercent = ((stats.correct || 0) / total) * 100
      
      if (correctPercent >= 80) return 'excellent'
      if (correctPercent >= 60) return 'good'
      if (correctPercent >= 40) return 'medium'
      return 'bad'
    },

    getResultText(stats) {
      if (!stats) return ''
      
      const total = (stats.correct || 0) + (stats.wrong || 0) + (stats.skipped || 0)
      const correctPercent = Math.round(((stats.correct || 0) / total) * 100)
      
      if (correctPercent >= 80) return 'A’lo'
      if (correctPercent >= 60) return 'Yaxshi'
      if (correctPercent >= 40) return 'Qoniqarli'
      return 'Qoniqarsiz'
    },

    getSuccessWidth(stats) {
      if (!stats) return 0
      const total = (stats.correct || 0) + (stats.wrong || 0) + (stats.skipped || 0)
      return total ? ((stats.correct || 0) / total) * 100 : 0
    },

    getDangerWidth(stats) {
      if (!stats) return 0
      const total = (stats.correct || 0) + (stats.wrong || 0) + (stats.skipped || 0)
      return total ? ((stats.wrong || 0) / total) * 100 : 0
    },

    getWarningWidth(stats) {
      if (!stats) return 0
      const total = (stats.correct || 0) + (stats.wrong || 0) + (stats.skipped || 0)
      return total ? ((stats.skipped || 0) / total) * 100 : 0
    }
  }
}
</script>

<style scoped>
.ticket-list {
  width: 100%;
}

.ticket-card {
  cursor: pointer;
  transition: all 0.2s ease;
  height: 100%;
}

.ticket-card:hover {
  transform: translateY(-2px);
}

.ticket-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.ticket-number {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.result-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

.result-badge.excellent {
  background: rgba(34, 197, 94, 0.2);
  color: var(--success);
}

.result-badge.good {
  background: rgba(34, 197, 94, 0.15);
  color: var(--success);
}

.result-badge.medium {
  background: rgba(245, 158, 11, 0.2);
  color: var(--warning);
}

.result-badge.bad {
  background: rgba(239, 68, 68, 0.2);
  color: var(--danger);
}

/* Test oralig'i stili */
.test-range {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  padding: 8px 0;
  border-bottom: 1px dashed var(--border);
}

.range-label {
  font-size: 13px;
  color: var(--text-soft);
}

.range-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--primary);
  background: rgba(59, 130, 246, 0.1);
  padding: 2px 10px;
  border-radius: 20px;
}

.stats-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 12px;
  padding: 8px 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
}

.stat-label {
  font-size: 11px;
  color: var(--text-soft);
}

.stat-item.success .stat-value {
  color: var(--success);
}

.stat-item.danger .stat-value {
  color: var(--danger);
}

.stat-item.warning .stat-value {
  color: var(--warning);
}

.progress-bar {
  display: flex;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);
}

.progress-segment {
  height: 100%;
  transition: width 0.3s ease;
}

.progress-segment.success {
  background: var(--success);
}

.progress-segment.danger {
  background: var(--danger);
}

.progress-segment.warning {
  background: var(--warning);
}

/* Empty state */
.empty-state {
  padding: 48px 0;
  text-align: center;
}

.empty-state :deep(.ant-empty-description) {
  color: var(--text-soft);
}

/* Loading */
:deep(.ant-spin) {
  color: var(--primary);
}

:deep(.ant-spin-dot i) {
  background-color: var(--primary);
}

/* Responsive */
@media (max-width: 768px) {
  .ticket-number {
    font-size: 15px;
  }
  
  .range-value {
    font-size: 14px;
  }
  
  .stat-value {
    font-size: 16px;
  }
  
  .stat-label {
    font-size: 10px;
  }
}
</style>